if (!customElements.get('quick-shop')) {
  class QuickShop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quick-shop-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          this.onPopupToggle();
        });
      });

      // Bind option select events
      this.querySelectorAll('[data-quick-shop-option]').forEach((option) => {
        option.addEventListener('click', () => {
          this.onOptionSelect(option.value, option.dataset.inventoryQuantity);
        });
      });
    }

    /**
     * onPopupToggle
     * @description Toggles the options popup on touch devices.
     */
    onPopupToggle() {
      this.parentCard.classList.toggle('quick-shop--is-open');
    }

    /**
     * onOptionSelect
     * @description Adds the clicked option/variant to the cart leveraging the product form component. Adds a variant to the cart.
     * @param {String} variantId
     * @param {String} inventoryQuantity
     */
    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      submitButton.click();

      this.parentCard.classList.remove('quick-shop--is-open');
    }
  }

  window.QuickShop = QuickShop;
  customElements.define('quick-shop', QuickShop);
}
